import React from 'react';

const Modal = ({ 
  isOpen, 
  onClose, 
  title = "Modal Window", 
  children,
  size = "default" // "small", "default", "large"
}) => {
  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Escape') {
      onClose();
    }
  };

  // Don't render if not open
  if (!isOpen) return null;

  // Size classes for different modal sizes
  const sizeClasses = {
    small: 'max-width: min(60vh, 90vw); width: min(60vh, 90vw); height: 60vh;',
    default: 'max-width: min(80vh, 90vw); width: min(80vh, 90vw); height: 80vh;',
    large: 'max-width: min(95vh, 95vw); width: min(95vh, 95vw); height: 90vh;'
  };

  return (
    <div 
      className="ph-modal-backdrop"
      onClick={handleBackdropClick}
      onKeyDown={handleKeyDown}
      tabIndex={-1}
    >
      <div 
        className="ph-modal-content"
        style={{ 
          maxWidth: size === 'small' ? 'min(60vh, 90vw)' : size === 'large' ? 'min(95vh, 95vw)' : 'min(80vh, 90vw)',
          width: size === 'small' ? 'min(60vh, 90vw)' : size === 'large' ? 'min(95vh, 95vw)' : 'min(80vh, 90vw)',
          height: size === 'small' ? '60vh' : size === 'large' ? '90vh' : '80vh'
        }}
      >
        {/* Close Button */}
        <button 
          onClick={onClose}
          className="ph-modal-close"
          aria-label="Close modal"
        >
          <span className="material-icons">close</span>
        </button>

        {/* Modal Header */}
        <div className="ph-modal-header">
          <h2 className="ph-modal-title">{title}</h2>
        </div>

        {/* Modal Body */}
        <div className="ph-modal-body">
          {children}
        </div>
      </div>
    </div>
  );
};

export default Modal;